import React from "react";
import { Link } from "@quintype/components";
import { MediaObject } from "../basic/media-object-list.js"
import { CollectionName } from "../basic/collection-name.js";
import { DfpAd } from "../dfp-ad";
import {collectionSection} from "../collection-templates/collection-layout-helper";

function FullscreenMediaList(props) {
  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5,3]
  }

  const limit = props.config.limit || 3;

  if(props.stories.length < 1) {
    return <div></div>
  }

  return <div className="fullscreen-media-list" data-test-id = "list-component">
    <div className="fullscreen-media-list__content component-wrapper">
      {
        !props.HideSectionName && <CollectionName className="fullscreen-media-list__section-name" name={props.config['collection-name']} type="large" section={props.collection}/>
      }
      <div className="fullscreen-media-list__stories">
        {props.stories.slice(0,limit)
          .map(storyObj => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return <div className="fullscreen-media-list__object" data-load-more-object="true" key={story.id}>
              <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config['collection-color']}/>
            </div>
          }
        )}
        { !props.hideLoadmore &&
          <div className="load-more" data-test-id = "full-screen-media-list-loadmore">
            {
              props.getMoreStories ? <button data-test-id = "load-more" onClick={props.getMoreStories}>Load More</button> :
              <Link href={'/' + props.config['collection-slug']}>
                Read more
              </Link>
            }
          </div>
        }
      </div>
      <div>
        {
          props.adSlot && <div className="app-ad app-ad--vertical">
            <DfpAd adtype="Vertical-Ad" layoutName="FullscreenMediaList" collectionSlug={props.config['collection-slug']}/>
          </div>
        }
      </div>
    </div>
  </div>
}

export { FullscreenMediaList };
